import type { ReactNode } from 'react';
import styles from '../ViinitieBanner.module.scss';

export type BannerWrapperProps = {
  linkUrl: string;
  onClick?: () => void;
  children: ReactNode;
};

export function BannerWrapper(props: BannerWrapperProps): ReactNode {
  return (
    <div className={styles.container}>
      <div className={styles.banner}>
        <a
          href={props.linkUrl}
          target="_blank"
          rel="noopener noreferrer external"
          onClick={props.onClick}
        >
          <div className={styles.adDisclaimer}>MAINOS</div>
          {props.children}
        </a>
      </div>
    </div>
  );
}
